import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { environmentOm } from '../../../../environment-om';
import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';

@Component({
    selector: 'om-municipality-asset-tip-report',
    templateUrl: './municipalityAssetTipReport.html',
    styleUrls: ['../../reports.css', './municipalityAssetTipReport.css']
})

export class MunicipalityAssetTipReportComponent implements OnInit, AfterViewInit {
    reportData: any = null;
    isGenerating = true;
    isLoadingMap = false;
    error = false;
    errorMessage = this.reportHelper.reportErrorMessages.noReportData;
    municipalCode;
    countyCode;
    countyMunicipalityCode;
    municipalName = '';
    countyName = '';
    summary: IReportSummary;

    @ViewChild('mcMap', { static: false }) mapRef: ElementRef<any>;
    defaultBasemap = {
        tileUrl: environmentOm.basemapURL + '/rest/services/basemaps/penndotbasemap/MapServer/tile',
        thumbnailTile: '/7/48/36',
        tileTemplate: '/{level}/{row}/{col}',
        title: 'PennDOT'
    };

    constructor(private readonly reportHelper: ReportHelper,
        private readonly reportsApi: ReportsApi,
        private readonly route: ActivatedRoute,
        titleService: Title) {
        titleService.setTitle(titleService.getTitle() + ' : Municipality Asset TIP Report');
    }

    ngOnInit() {
        this.isGenerating = true;
        this.route.paramMap.subscribe(x => {
            const params = JSON.parse(window.localStorage.getItem(x.get('id')));
            const splitIndex = 2;
            this.countyMunicipalityCode = params.countyMunicipalityCode;
            this.countyCode = this.countyMunicipalityCode.substring(0, splitIndex);
            this.municipalCode = this.countyMunicipalityCode.substring(splitIndex);
            this.loadReport();
            this.isGenerating = false;
        });
    }

    ngAfterViewInit() {
        this.loadMap();
    }

    async loadReport() {
        this.reportsApi.getMunicipalityAssetTipReportData(this.countyCode, this.municipalCode).then(async (reportData) => {
            this.reportData = reportData;
            await this.getMunicipalName();
            await this.getCountyName();
        });
    }

    private async getMunicipalName() {
        this.municipalName = await this.reportHelper.getMunicipalNameFromId([this.countyCode], this.municipalCode);
    }
    private async getCountyName() {
        this.countyName = await this.reportHelper.getCountyNameFromId(this.countyCode);
    }

    private async loadMap() {
        this.isLoadingMap = true;
        this.reportHelper.getLayerIdByName('MPMS - TIP - All').then(async (result) => {
            const layerId = result[0].id;
            const symbols = this.reportHelper.getBoundaryLayerProperties(this.mapRef.nativeElement.LayerService.legendService);
            try {
                await this.mapRef.nativeElement.ready;
                await this.mapRef.nativeElement.setBasemapsFromConfig(this.defaultBasemap);
                const layerSettings = [{
                    id: parseInt(layerId, 10),
                    query: {
                        operator: 'AND', subqueries: [
                            { field: 'cty_code', operator: '=', value: this.countyCode },
                            { field: 'municipality_codes', operator: 'INCLUDES', value: this.municipalCode },
                            { field: 'tip_flag', operator: '=', value: 'Y' }
                        ]
                    }
                },
                {
                    id: environmentOm.layers.filter(x => x.name === 'municipality')[0].id,
                    query: {
                        operator: 'AND', subqueries: [
                            { field: 'county', operator: '=', value: this.countyCode },
                            { field: 'municipal_code', operator: '=', value: this.municipalCode }
                        ]
                    },
                    opacity: 0.5,
                    symbols,
                    zoomToLayer: true,
                    generateNewLayer: true
                }];
                this.mapRef.nativeElement.LayerService.addMapcoreLayersToMap([...layerSettings].reverse());
                this.isLoadingMap = false;
            } catch (error) {
                this.isLoadingMap = false;
            }
        });
    }
}

interface IReportSummary {
    totalNumberOfStateBridges: string;
    totalNumberOfLocalBridges: string;
    totalNumberofTipProjects: string;
    totalIriMiles: string;
    fedAidMiles: string;
    poorIri: string;
    fairIri: string;
    goodIri: string;
    excellentIri: string;
}
